import { useCallback } from "react";
import { changeAppLanguage, writeStoredLocale, type SupportedLocale } from "@patient-watch/i18n";
import { useAuth } from "@/utils/auth";
import { useAppLocale } from "./LocaleProvider";
import { usePreferredLocaleMutation } from "./usePreferredLocaleMutation";

/** Set locale for guests (localStorage) and signed-in users (also persists to profile). */
export function useSetAppLocale() {
    const auth = useAuth();
    const { setLocale: setContextLocale } = useAppLocale();
    const mutation = usePreferredLocaleMutation(auth.id ?? "");

    return useCallback(
        (locale: SupportedLocale) => {
            writeStoredLocale(locale);
            setContextLocale(locale);
            void changeAppLanguage(locale);
            if (auth.id) {
                mutation.mutate(locale);
            }
        },
        [auth.id, mutation, setContextLocale]
    );
}
